<template>
  <div id="patient-dispense-report-v1-slxs8w" class="fb-patient-dispense-report-v1">
    <div id="patient-vital-v1-jwwirf" v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group id="patient-dispense-report-v1-b8uckn"
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table id="patient-dispense-report-v1-l6blt9"
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      </b-form-group>
    </div>
    <div id="patient-dispense-report-v1-yi4n38" v-else-if="showType == 'properties'">
      <emar-patient-dispense-report-v1-properties id="patient-dispense-report-v1-oh66e7" :formId="formId" />
    </div>
    <div id="patient-dispense-report-v1-pd302e"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
        (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
      class="medication-table-container"
      v-show="!computedHidden"
    >
      <b-form-group id="patient-dispense-report-v1-l8gqjt"
        :description="computedPropertiesForm.description"
        :style="properties.style"
      >
        <template v-slot:label="">
          <div id="patient-dispense-report-v1-n2r2ft" class="d-flex align-items-center justify-content-between">
            <span id="patient-dispense-report-v1-to4v3l" style="font-size: 16px" class="mr-3">
              {{
                computedPropertiesForm.label
              }}
            </span>
            <b-button id="patient-dispense-report-v1-abw11u" @click="fetchDispenseReport" variant="primary" class="mr-2"
              ><i id="patient-dispense-report-v1-u97567" class="fa fa-sync-alt mr-2"></i> Reload Dispense Report</b-button
            >
          </div>
        </template>
        <b-table id="patient-dispense-report-v1-0uvbfx"
          class="custom-fb-table"
          responsive
          striped
          hover
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        >
          <template #cell(medication)="data">
              <div>
               {{ data.item.medication }}<br>
               Effective Date: {{ data.item.effectiveDate }}<br>
               Sig: {{ data.item.sig }}
              </div>
          </template>

        </b-table>
        <div id="patient-dispense-report-v1-v7oax1" v-if="emarErrorMessage" class="text-danger text-center">
          {{ emarErrorMessage }}
        </div>
      </b-form-group>
    </div>
    <div id="patient-dispense-report-v1-3uumpn"
      v-if="showType == 'form-viewer' || showType == 'e-form'"
      :style="properties.style"
      class="medication-table-container"
    >
      <b-form-group id="patient-dispense-report-v1-kre65i"
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table id="patient-dispense-report-v1-ql6qzn"
            responsive
            :items="tableProperties.items"
            :fields="tableProperties.columns"
          ></b-table>
        <div id="patient-dispense-report-v1-ya6eel" v-if="emarErrorMessage" class="text-danger text-center">{{emarErrorMessage}}</div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import EmarPatientDispenseReportV1Properties from "./EmarPatientDispenseReportV1Properties.vue";
import emarServer from "../../../../server/emar";
import { formatDateISO, formatDate } from "../../../../helpers/date";

export default {
  name: "EmarPatientDispenseReportV1",
  components: { EmarPatientDispenseReportV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      emarErrorMessage: null,
      medications: [],
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      startDate: null,
      fromDate: null,
    };
  },
  async mounted() {
    if (this.showType != "form-builder") {
      if (
        this.getFormSubmitterComponentValue(this.id) &&
        (this.showType == "form-submitter" || this.showType == "e-form")
      ) {
        const value = this.getFormSubmitterComponentValue(this.id);
        this.medications = value.medications;
        this.emarErrorMessage = value.error;
      } else if (
        this.showType == "form-submitter" ||
        this.showType == "e-form" ||
        this.showType == "form-viewer"
      ) {
        this.fetchDispenseReport();
      }
    }

    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";
      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:16px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="8" class="table b-table custom-fb-table mt-2 table-striped table-responsive table-hover" id="__BVID__50" style="width: 100%; font-size: 11px; table-layout: fixed;">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                        <th role="columnheader" scope="col" aria-colindex="1" class="" style="width: 12%; max-width: 12%; font-size: 12px; padding: 2px 3px;">
                          <div>Dispensed</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="2" class="" style="width: 12%; max-width: 12%; font-size: 12px; padding: 2px 3px;">
                          <div>Scheduled</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="4" class="" style="width: 12%; max-width: 12%; font-size: 12px; padding: 2px 3px;">
                           <div>Drug</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="8" class="" style="width: 15%; max-width: 15%; font-size: 12px; padding: 2px 3px;">
                          <div>Drug Quantity</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="9" class="" style="width: 10% !important; max-width: 10% !important; min-width: 10% !important; font-size: 12px !important; padding: 2px 3px !important; overflow: visible !important; white-space: nowrap !important;">
                          <div>Drug Uom</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="9" class="" style="width: 10% !important; max-width: 10% !important; min-width: 10% !important; font-size: 12px !important; padding: 2px 3px !important; overflow: visible !important; white-space: nowrap !important;">
                          <div>Status</div>
                        </th>
                        <th role="columnheader" scope="col" aria-colindex="9" class="" style="width: 10% !important; max-width: 10% !important; min-width: 10% !important; font-size: 12px !important; padding: 2px 3px !important; overflow: visible !important; white-space: nowrap !important;">
                          <div>Administered By</div>
                        </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    (item) => `
                      <tr role="row" class="">
                      <td aria-colindex="1" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.dispensed}</td>
                      <td aria-colindex="2" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.scheduled}</td>
                      <td aria-colindex="3" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.drug}</td>
                      <td aria-colindex="4" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.drugQuantity}</td>
                      <td aria-colindex="5" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.drugUom}</td>
                      <td aria-colindex="6" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.status}</td>
                      <td aria-colindex="7" role="cell" class="" style="font-size: 11px; padding: 2px 3px;">${item.administeredBy??""}</td>
                    </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    },
    fetchDispenseReport() {
      if (this.showType == "form-submitter" || this.showType == "e-form" || this.showType == "form-viewer") {
        if (!this.client || !this.client.id) {
          this.emarErrorMessage = "Client information is not available.";
          this.medications = [];
          return;
        }
        
        emarServer
          .getDispenseReport(this.client.id, this.startDate, this.fromDate,  { "Show-Alert-Error": false })
          .then((dispenseReportList) => {
            this.emarErrorMessage = null;
            this.medications = [];
            for (const dispenseReport of dispenseReportList) {
              this.medications.push({
                ...dispenseReport,
                dispensed: formatDate(dispenseReport.dispensed, "Not Yet Dispensed"),
                scheduled: formatDate(dispenseReport.scheduled),
              });
            }
            if (this.showType == "form-submitter" || this.showType == "e-form") {
              this.setFormSubmitterComponentValue({
                controlId: this.id,
                controlValue: {
                  medications: this.medications,
                  error: this.emarErrorMessage,
                },
                userAction: true,
                hardSet: true,
              });
            }
          })
          .catch((error) => {
            this.medications = [];
            if (error.response && error.response.data && error.response.data.errorCode == "emarDisabled") {
              this.emarErrorMessage =
                "Your tenant doesn't have Emar enabled. Please contact your administrator to get access.";
            }
            if (error.response && error.response.data && error.response.data.errorCode == "patientNotSynchronized") {
              this.emarErrorMessage =
                "This patient has not been synced with Emar. Please synchronize the patient before using this component.";
            }
            if (this.showType == "form-submitter" || this.showType == "e-form") {
              this.setFormSubmitterComponentValue({
                controlId: this.id,
                controlValue: {
                  medications: this.medications,
                  error: this.emarErrorMessage,
                },
                userAction: true,
                hardSet: true,
              });
            }
          });
      }
    },
    calculateDateRange(documentEffectiveDate, filterType, value = 0) {
      const endDate = new Date(documentEffectiveDate);
      endDate.setHours(23, 59, 59, 999);
      const startDate = new Date(documentEffectiveDate);

      switch (filterType) {
        case "days":
          startDate.setDate(startDate.getDate() - (value - 1));
          break;
        case "months":
          startDate.setMonth(startDate.getMonth() - value);
          break;
        case "current":
          break;
      }

      startDate.setHours(0, 0, 0, 0);
      return { startDate, endDate };
    },
    updateRange(documentEffectiveDate, filterType, value = 0) {
      const { startDate, endDate } = this.calculateDateRange(documentEffectiveDate, filterType, value);
      this.startDate = formatDateISO(startDate);
      this.fromDate = formatDateISO(endDate);
    },
    updateRangeByDocumentEffectiveDate() {
      const documentEffectiveDate = this.document?.effectiveDate ? new Date(this.document.effectiveDate) : new Date();
      if(this.properties.dateFilter === "currentday"){
        this.updateRange(documentEffectiveDate, "current");
      }
      else if(this.properties.dateFilter === "last7days"){
        this.updateRange(documentEffectiveDate, "days", 7);
      }
      else if(this.properties.dateFilter === "last30days"){
        this.updateRange(documentEffectiveDate, "days", 30);
      }
      else if(this.properties.dateFilter === "last3months"){
        this.updateRange(documentEffectiveDate, "months", 3);
      }
    },
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    ...mapState("formSubmitter", {
      client: (state) => state.form.client,
      currentPage: (state) => state.form.currentPage,
      document: (state) => state.form.document
    }),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    tableProperties() {
      let items = this.medications;
      
      if (this.showType != "form-builder") {
        this.updateRangeByDocumentEffectiveDate();
      }
      
      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "dispensed",
            label: "Dispensed",
          },
          {
            key: "scheduled",
            label: "Scheduled",
          },
          {
            key: "drug",
            label: "Drug",
          },
          {
            key: "drugQuantity",
            label: "Drug Quantity",
          },
          {
            key: "drugUom",
            label: "Drug Uom",
          },
          {
            key: "status",
            label: "Status",
          },
          {
            key: "administeredBy",
            label: "Administered By",
          }
        ],
      };
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
  },
  watch:{
    "document.effectiveDate":{
      handler: function(newValue, oldValue) {
        if(oldValue && newValue !== oldValue) {
          this.updateRangeByDocumentEffectiveDate();
          this.fetchDispenseReport();
        }
      }
    },
    "client.id": {
      handler: function(newValue, oldValue) {
        if (newValue && newValue !== oldValue && (this.showType == "form-submitter" || this.showType == "e-form" || this.showType == "form-viewer")) {
          this.fetchDispenseReport();
        }
      },
      immediate: false
    }
  }
};
</script>

<style scoped>
.medication-table-container >>> td {
  min-width: 130px;
}
.custom-fb-table th,
.custom-fb-table td {
  padding: 5px !important;
  vertical-align: middle !important;
}
.custom-fb-table td {
  font-size: 12px;
  padding-left: 17px;
}
.custom-fb-table th {
  font-size: 14px;
  padding-left: 17px;
}
</style>

